import React, {useEffect, useState} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {errorlog, showlog} from "../../../utils/dev-utils";
import {setEvaluationStatus} from "../../../business-logic/rating";
import {PATH_PREFIX} from "../../../env";
import ActionButton from "../../save-button";
import {translate} from "../../i18n/translate-function";


export const CertificateRatingConfirmModal = props => {

	const [inWait, inWaiting] = useState( false );


		let content = (
			<Modal isOpen={ true } >
				<ModalHeader className={""}>
					<span>Attenzione</span>
				</ModalHeader>
				<ModalBody >
					<span>
						Si sta per procedere alla certificazione della valutazione.<br/><br/>Premere OK se si desidera procedere, oppure premere Annulla.
					</span>
				</ModalBody>
				<ModalFooter>

					<ActionButton
						buttonText={"OK"}
						promise={ () => setEvaluationStatus(props.id, false, false, true) }
						onProcess={ () => {
							inWaiting( true );
						}}
						onResult={ result => {
							if( !!props.isGenderGap ) {
								window.location.href = PATH_PREFIX + "/" + translate("gender-gap") + "/" + translate("evaluations");
							}
							else {
								window.location.href = PATH_PREFIX + "/sirating-admin/" + translate("evaluations");
							}
						}}
						onError={ error => {
							errorlog("Certificazione con commento", error );
						}}
					/>

					{' '}

					<Button
						color="link"
						onClick={ clickEvent => {
							props.onClose();
						}}
					>
						Annulla
					</Button>
				</ModalFooter>
			</Modal>


		);


		return content;

}
